import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disabled", "hasEditableReview", "onClick", "size", "tooltipPlacement", "unreviewableReason"];
import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { getAppShortlink } from '../../../utils/urls';
// @ts-expect-error untyped dependency
import { getIsPublic } from '../../../selectors/auth';
import { jsx as _jsx } from "react/jsx-runtime";
export default function WriteReviewButton(_ref) {
  let {
      disabled = false,
      hasEditableReview,
      onClick,
      size = 'sm',
      tooltipPlacement = 'left',
      unreviewableReason
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    pathname
  } = useLocation();
  const isPublic = useSelector(getIsPublic);
  const isReviewable = !unreviewableReason || unreviewableReason !== 'ReviewError.EDIT_PENDING' && hasEditableReview;
  if (isPublic) {
    return /*#__PURE__*/_jsx(Button, Object.assign({
      href: getAppShortlink(`${pathname}/write-review`),
      use: "tertiary",
      size: size
    }, rest, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.detail.reviews.write.button"
      })
    }));
  }
  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `marketplace-ui-reviews.error.${unreviewableReason}`
      }),
      disabled: isReviewable,
      placement: tooltipPlacement,
      children: /*#__PURE__*/_jsx(Button, Object.assign({
        onClick: onClick,
        use: hasEditableReview ? 'tertiary-light' : 'tertiary',
        size: size,
        disabled: disabled || !isReviewable
      }, rest, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `appMarketplace.detail.reviews.write.${hasEditableReview ? 'edit' : 'button'}`
        })
      }))
    })
  });
}